import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// redux
import { selectSocialLimitErrorDialog } from '../reducers/social/socialReducer';
import { setSocialLimitErrorDialog } from '../actions';

import CommentReachedLimitDialog from './CommentReachedLimitDialog';
import LikeReachedLimitDialog from './LikeReachedLimitDialog';

const LimitErrorDialog = () => {
    const dispatch = useDispatch();
    const { open, errorType } = useSelector(selectSocialLimitErrorDialog);
    const onClose = () => {
        dispatch(setSocialLimitErrorDialog({ open: false, errorType }));
    };

    if (errorType === 'comment') {
        return <CommentReachedLimitDialog open={open} onClose={onClose} />;
    }
    if (errorType === 'like') {
        return <LikeReachedLimitDialog open={open} onClose={onClose} />;
    }
    return null;
};

export default LimitErrorDialog;
